module.exports = __webpack_public_path__ + "img/法律.92b812f2.png";